// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FrIyDC89rw617YeCYwZB{color:var(--content-primary-primary);cursor:pointer;flex-direction:row;align-items:center;gap:8px;font-size:13px;font-weight:400;display:flex}.jbU0RHtbSKsOag9z83Ld{pointer-events:none;justify-content:center;min-width:32px;max-width:32px;display:flex}.GuXPDb5ED00jqDpewpEJ{height:40px}.gPjTKkxRoHgglyJrcI4o{margin-left:6px}.pdrBNBkSnMEjgYKpFc86{background:var(--white-100);justify-content:space-between;padding:32px 0 64px;display:flex;position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publishButton": `FrIyDC89rw617YeCYwZB`,
	"publishButtonControl": `jbU0RHtbSKsOag9z83Ld`,
	"footerButton": `GuXPDb5ED00jqDpewpEJ`,
	"selectItemIcon": `gPjTKkxRoHgglyJrcI4o`,
	"footer": `pdrBNBkSnMEjgYKpFc86`
};
export default ___CSS_LOADER_EXPORT___;
